import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services'

export const getClientesLista = async () => {
  const res = await getData('/usuarios');
  return res
}

export const getClientesPanel = async (searchTerm, searchSel, page, perPage) => {
  let queryParams = [];
  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm || '')}`);
  } 
  if (searchSel) {
    queryParams.push(`emp_codigo=${encodeURIComponent(searchSel || '')}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/usuarios", queryString);
};

export const getXCliente = async (searchTerm) => {
  return await getData("/usuarios", `?cli_name=${searchTerm}`);
};

export const getClienteById = async (id) => {
  const res = await getData(`/usuarios/${id}`)
  return res
}

export const postCliente = async (body) => {
  const res = await postData('/usuarios/panel', body)
  return res
}

export const patchCliente = async (id, body) => {
  const res = await patchData(`/usuarios/panel/${id}`, body)
  return res
}

export const deleteCliente = async (id) => {
  const res = await deleteData(`/usuarios/${id}`)
  return res
}

// ═══════════════════════════════════════════════════════════════════════════
// Permitir / bloquear edición de clientes de un preventista
// ═══════════════════════════════════════════════════════════════════════════
export const permitirEdicion = async (emp_id, option) => {
  const empId = emp_id ?? 0;

  return await patchData("/permisos/option1", {
    empleado_id: empId,
    option,
  });
};
